import * as React from 'react';
import { useSelector } from 'react-redux';
import { ArticleParagraph2 } from '@cian/ui-kit';
import * as styles from './styles.css';

import { hasNotItems } from '../../selectors/listing';
import { ADVERTISING_LABELING_TEXT } from '../../constants/advertisingLabeling';

export const AdvertisingLabelingContainer = () => {
  const isEmpty = useSelector(hasNotItems);

  if (isEmpty) {
    return null;
  }

  return (
    <div className={styles['text']}>
      <ArticleParagraph2 color={'black_60'}>{ADVERTISING_LABELING_TEXT}</ArticleParagraph2>
    </div>
  );
};

AdvertisingLabelingContainer.displayName = 'AdvertisingLabelingContainer';
